import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Drawer,
  Divider,
  IconButton,
  Link,
  Typography,
  Grid,
  Button,
} from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import HomeIcon from "@material-ui/icons/Home";

// Contexts
import AuthContext from "../../context/auth/AuthContext";
import ParameterContext from "../../context/parameters/ParameterContext";
import DashboardContext from "../../context/facebook_profiles/dashboard/DashboardContext";

const Sidebar = ({ openState, drawerWidth }) => {
  const useStyles = makeStyles((theme) => ({
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      borderStyle: "none",
    },
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: theme.palette.primary.dark,
      borderStyle: "none",
    },
    drawerHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      justifyContent: "space-between",
      marginLeft: theme.spacing(2),
      borderStyle: "none",
    },
    listHeader: {
      marginLeft: theme.spacing(3),
      marginTop: theme.spacing(2),
      color: theme.palette.primary.contrastText,
    },
    listBody: {
      marginLeft: theme.spacing(3),
    },
    buttonLink: {
      color: theme.palette.primary.contrastText,
      textAlign: "left",
      "&:hover": {
        background: theme.palette.primary.light,
      },
      "&:focus": {
        outline: "none",
      },
      width: "100%",
      textTransform: "none",
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();

  const { isAuthenticated, user } = useContext(AuthContext);
  const shopify_menu_list = [
    {
      title: "Shopify",
      name: "Campaign",
      link: "/campaign",
    },
    {
      title: "Shopify",
      name: "Report",
      link: "/report",
    },
    {
      title: "Shopify",
      name: "Domain",
      link: "/domain",
    },
    {
      title: "Shopify",
      name: "Avatar",
      link: "/avatar",
    },
    {
      title: "Shopify",
      name: "Paypal Tracking",
      link: "/tracking",
    },
    {
      title: "Facebook",
      name: "Profile",
      link: "/facebook/profile",
    },
    {
      title: "Facebook",
      name: "Error",
      link: "/facebook/error",
    },
  ];
  const { getFacebookError } = useContext(DashboardContext);

  const [sidebar_list, setSidebarList] = useState();
  const [open, setOpen] = openState;

  const drawerTitleSize = 17;
  const drawerItemSize = 14;

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const onClick = (link) => {
    history.push(link);
  };

  useEffect(() => {
    if (isAuthenticated && shopify_menu_list) {
      let temp_list = {};

      shopify_menu_list.forEach((each) => {
        if (each.title in temp_list) {
          temp_list[each.title].push(each);
        } else {
          temp_list[each.title] = [each];
        }
      });
      setSidebarList(temp_list);
    } else {
      setSidebarList(null);
    }
  }, [isAuthenticated, user]);

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
      style={{
        zIndex: -10,
      }}
    >
      {sidebar_list ? (
        <Fragment>
          {/* Dashboard */}
          <div className={classes.drawerHeader}>
            <Link
              onClick={() => onClick("/")}
              style={{
                textDecoration: "none",
                color: "#ffffff",
              }}
            >
              <Grid container direction="row" spacing={1}>
                <Grid item>
                  <HomeIcon
                    style={{
                      fontSize: 22,
                      color: theme.palette.primary.contrastText,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: 18,
                    }}
                  >
                    Conqore
                  </Typography>
                </Grid>
              </Grid>
            </Link>
            <IconButton
              onClick={handleDrawerClose}
              className={classes.buttonOutline}
            >
              <ChevronLeftIcon
                style={{
                  color: "#ffffff",
                }}
              />
            </IconButton>
          </div>
          <Divider
            style={{
              backgroundColor: "#ffffff",
            }}
          />

          {/* Sidebar */}
          {Object.entries(sidebar_list).map(([title, links]) => {
            return (
              <Grid key={title} container direction="row">
                <Grid item xs={12} className={classes.listHeader}>
                  <Typography
                    style={{
                      fontSize: drawerTitleSize,
                    }}
                  >
                    {title}
                  </Typography>
                </Grid>
                {links.map((each) => {
                  let a = window.location.pathname + "/";
                  let b = each.link + "/";
                  let selected = a.includes(b);

                  return (
                    <Grid
                      key={each.link}
                      item
                      xs={12}
                      className={classes.listBody}
                    >
                      <Button
                        onClick={() => onClick(each.link)}
                        className={classes.buttonLink}
                        style={
                          selected
                            ? {
                                backgroundColor: theme.palette.primary.light,
                              }
                            : null
                        }
                      >
                        <Typography
                          style={{
                            fontSize: drawerItemSize,
                            width: "100%",
                          }}
                        >
                          {each.name}
                        </Typography>
                      </Button>
                    </Grid>
                  );
                })}
              </Grid>
            );
          })}
        </Fragment>
      ) : null}
    </Drawer>
  );
};

export default Sidebar;
